import {scActions} from './schema-comparison.actions';
import {savedRunToCompareResult} from './savedRunToCompareResult';

export const initialState = {
  connections: [],
  sourceSchemas: [],
  targetSchemas: [],
  ddSchemas: [],
  objectList: null,
  compareResult: null,
  impactResult: null,
  history: [],
  savedRun: null,
  isLoading: [],
  error: [],
};

const schemaComparisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case scActions.LOAD_CONNECTIONS_REQUEST:
      return {...state, isLoading: [...state.isLoading, 'loadConnections']};
    case scActions.LOAD_CONNECTIONS_SUCCESS:
      return {
        ...state,
        connections: (action.payload && action.payload.response) ? action.payload.response : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadConnections'),
        error: [],
      };
    case scActions.LOAD_CONNECTIONS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadConnections'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_DD_SCHEMAS_REQUEST:
      return {...state, isLoading: [...state.isLoading, 'loadDdSchemas']};
    case scActions.LOAD_DD_SCHEMAS_SUCCESS:
      return {
        ...state,
        ddSchemas: (action.payload && action.payload.response) ? action.payload.response : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadDdSchemas'),
        error: [],
      };
    case scActions.LOAD_DD_SCHEMAS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadDdSchemas'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_SOURCE_SCHEMAS_REQUEST:
      return {...state, sourceSchemas: [], isLoading: [...state.isLoading, 'loadSourceSchemas']};
    case scActions.LOAD_SOURCE_SCHEMAS_SUCCESS:
      return {
        ...state,
        sourceSchemas: (action.payload && action.payload.response) ?
          (action.payload.response.schemas || action.payload.response) : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadSourceSchemas'),
        error: [],
      };
    case scActions.LOAD_SOURCE_SCHEMAS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadSourceSchemas'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_TARGET_SCHEMAS_REQUEST:
      return {...state, targetSchemas: [], isLoading: [...state.isLoading, 'loadTargetSchemas']};
    case scActions.LOAD_TARGET_SCHEMAS_SUCCESS:
      return {
        ...state,
        targetSchemas: (action.payload && action.payload.response) ?
          (action.payload.response.schemas || action.payload.response) : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadTargetSchemas'),
        error: [],
      };
    case scActions.LOAD_TARGET_SCHEMAS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadTargetSchemas'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_OBJECTS_REQUEST:
      return {...state, objectList: null, isLoading: [...state.isLoading, 'loadObjects']};
    case scActions.LOAD_OBJECTS_SUCCESS:
      return {
        ...state,
        objectList: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'loadObjects'),
        error: [],
      };
    case scActions.LOAD_OBJECTS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadObjects'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.RUN_COMPARISON_REQUEST:
      return {...state, compareResult: null, isLoading: [...state.isLoading, 'runComparison']};
    case scActions.RUN_COMPARISON_SUCCESS:
      return {
        ...state,
        compareResult: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'runComparison'),
        error: [],
      };
    case scActions.RUN_COMPARISON_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'runComparison'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_IMPACT_REQUEST:
      return {...state, impactResult: null, isLoading: [...state.isLoading, 'loadImpact']};
    case scActions.LOAD_IMPACT_SUCCESS:
      return {
        ...state,
        impactResult: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'loadImpact'),
        error: [],
      };
    case scActions.LOAD_IMPACT_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadImpact'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_HISTORY_REQUEST:
      return {...state, isLoading: [...state.isLoading, 'loadHistory']};
    case scActions.LOAD_HISTORY_SUCCESS:
      return {
        ...state,
        history: (action.payload && action.payload.response) ? action.payload.response : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadHistory'),
        error: [],
      };
    case scActions.LOAD_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadHistory'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.LOAD_SAVED_RUN_REQUEST:
      return {...state, savedRun: null, isLoading: [...state.isLoading, 'loadSavedRun']};
    case scActions.LOAD_SAVED_RUN_SUCCESS: {
      const savedRun = (action.payload && action.payload.response) ? action.payload.response : null;
      return {
        ...state,
        savedRun,
        // A saved run drives the SAME results view as a fresh comparison, so
        // reshape it into compareResult (the page renders off compareResult).
        compareResult: savedRunToCompareResult(savedRun),
        impactResult: null,
        isLoading: state.isLoading.filter((k) => k !== 'loadSavedRun'),
        error: [],
      };
    }
    case scActions.LOAD_SAVED_RUN_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadSavedRun'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case scActions.CLEAR_RESULT:
      return {...state, compareResult: null, impactResult: null};

    default:
      return state;
  }
};

export default schemaComparisonReducer;
